import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12a8 8 0 11-16 0 8 8 0 0116 0zm-5.53-2.53L11 12.94l-1.47-1.47-1.06 1.06 2 2 .53.53.53-.53 4-4-1.06-1.06z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12zm-7.319-2.867l-4.241 4.243-2.122-2.121-1.06 1.06 2.652 2.652.53.53.53-.53 4.772-4.774-1.06-1.06z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M45 24c0 11.598-9.402 21-21 21S3 35.598 3 24 12.402 3 24 3s21 9.402 21 21zm-14.637-5.734L21.88 26.75l-4.244-4.242-2.12 2.122 5.303 5.302 1.061 1.06 1.06-1.06 9.545-9.546-2.122-2.121z",
    clipRule: "evenodd"
  }))
};
export var CheckCircleFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});